exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emailDoesNotExistIcon[data-v-6206513a],.emailExistsIcon[data-v-6206513a],.fetchingIcon[data-v-6206513a]{float:right;margin-right:10px;margin-top:-27px;position:relative;z-index:2;cursor:default}.emailInvalid[data-v-6206513a]{color:#e0003f;margin-top:5px}.emailExistsIcon[data-v-6206513a]{color:#e0003f}.emailExistsText[data-v-6206513a]{color:#e0003f;margin-top:5px}.emailDoesNotExistIcon[data-v-6206513a]{color:green}", ""]);

// exports
